<template>
<div>
    <section class="page-title contrato pf-title">
        <div class="center">
            <router-link to="/servidorpublico" class="back-button fas fa-angle-left">
            </router-link>
            <p class="label-planos">Servidor Público</p>
            <h1 class="the-title">Contrato</h1>
        </div>
    </section>

    <section class="page-content center planos-form">    
    <div class="plano-selecionado" style="background: #f1f1f1;"><span>{{this.planoSelecionado.name}} - {{this.planoSelecionado.registro}} - R$ {{this.planoSelecionado.value}} (por pessoa) - {{this.planoSelecionado.cobertura}}</span></div>
    <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Primeiro Acesso</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2" :editable="editPassos" >Dados Pessoais</v-stepper-step>

      <v-divider></v-divider>
      
      <v-stepper-step :complete="e1 > 3" step="3" :editable="editPassos">Anexos</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 4" step="4" :editable="editPassos">Endereço</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 5" step="5" :editable="editPassos">Beneficiários</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="6" :editable="editPassos">Contratar o Plano</v-stepper-step>
    </v-stepper-header>
    <!-- PASSO 1 -->
    <v-stepper-items>
      <v-stepper-content step="1">
    <v-container grid-list-md>
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >   
        <v-layout row wrap>
            <v-flex xs12 sm12 lg6>      
            <v-text-field
            v-model="financialManagers.email"
            v-validate="'required|email'"
            :error-messages="errors.collect('email')"
            label="E-mail*"
            data-vv-name="email"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-text-field
            v-model="financialManagers.password"
            label="Senha*"
            v-validate="'required'"
            :error-messages="errors.collect('senha')"
            type="password"
            ref="password"
            data-vv-name="senha"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-text-field
            v-model="financialManagers.confirmPassword"
            label="Repetir Senha*"
            type="password"
            :error-messages="errors.collect('password')"
            v-validate="'required|confirmed:password'"
            data-vv-name="password"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg6>      
            <v-text-field
            v-model="financialManagers.firstName"
            label="Nome Completo*"
            box
            v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
            :error-messages="errors.collect('firstName')"
            data-vv-name="firstName"
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-text-field
            v-model="financialManagers.cellPhone"
            label="Celular*"
            return-masked-value mask="(##)#####-####"
            v-validate="'required'"   
            :error-messages="errors.collect('Celular')"
            data-vv-name="Celular"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-select
                box               
                v-model="financialManagers.state"
                :items="estados"
                item-text="prefix"
                item-value="codeS4"
                label="UF*"
                v-validate="'required'"
                :error-messages="errors.collect('uf')"
                data-vv-name="uf"
            ></v-select>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-validate="'required'"
            v-model="financialManagers.matricula"
            label="Matricula*"
            :error-messages="errors.collect('matricula')"
            data-vv-name="matricula"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="financialManagers.admissionDate"
            label="Data de Admissão*"
            v-validate="'required'"
            :error-messages="errors.collect('dateAdmission')"
            return-masked-value mask="##/##/####"
            data-vv-name="dateAdmission"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="financialManagers.cpf"
            label="CPF*"
            v-validate="'required|cpf'"
            :error-messages="errors.collect('cpf')"
            return-masked-value mask="###.###.###-##"
            data-vv-name="cpf"
            box
            ></v-text-field>
            </v-flex>
            <!-- <v-flex xs12 sm12 lg2>
            <v-text-field
            label="Nº de Vidas"
            disabled
            reverse
            ></v-text-field>   
            </v-flex>         
            <v-flex xs12 sm12 lg2>     
            <v-text-field
            disabled
            v-model="qtdTitular"
            label="Titular"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg2>      
            <v-text-field

            @keyup="calculaPlano(planoSelecionado)"
            v-model="financialManagers.qtdDependentes"
            mask="###"
            label="Dependentes"
            type="telephone"
            v-validate="'required'"
            :error-messages="errors.collect('qtdDepend')"
            data-vv-name="qtdDepend"
            box
            ></v-text-field>
            </v-flex> -->
            <v-flex xs12 sm12 lg12>      
            <p class="form-titulo">Resumo da proposta</p>
          </v-flex>           
          <v-flex xs12 sm12 lg2>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Beneficiário Titular</p>
              <span class="subtotal">R$ {{valorTitular.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg2>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Dependente(s)</p>
              <span class="subtotal">R$ {{valorDependentes}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg4>
          <div class="resumo" v-if="planoSelecionado.taxaImplantacao != '0,00'">
                  <p style="margin-bottom: 0px;">Total a pagar + Taxa de Implantação</p>
                  <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>                    
          </div>
          <div class="resumo" v-else>
              <p style="margin-bottom: 0px;">Total a pagar</p>
              <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
          </div>          
          <br>
          </v-flex> 
          <v-flex xs12 sm12 lg12  v-if="planoSelecionado.taxaImplantacao != '0,00'">
            <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pessoa (Apenas na primeira mensalidade)</p> 
          </v-flex>                   
        </v-layout>                
        </v-card> 
        <v-flex xs12 sm12 lg12>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#004899"
            @click="salvarPrimeiroAcesso()"
            >Continuar
        </v-btn>
        </v-flex>         
    </v-container>
      </v-stepper-content>
<!-- FIM DO PASSO 1 -->

<!-- PASSO 2 -->
      <v-stepper-content step="2">
    <v-container grid-list-md>
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-layout row wrap>
            <v-flex xs12 sm12 lg8>      
            <v-text-field
            v-model="financialManagers.firstName"
            label="Nome Completo*"
            box
            disabled
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-select
            v-model="financialManagers.gender"
            label="Sexo*"
            v-validate="'required'"
            :error-messages="errors.collect('gender')"
            data-vv-name="gender"
            :items="generos"
            item-text="text"
            item-value="value"
            box
            ></v-select>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="dataNasc"
            label="Data de Nascimento*"
            v-validate="'required|date_format:dd/MM/yyyy'"
            :error-messages="errors.collect('dateOfBirth')"
            return-masked-value mask="##/##/####"
            data-vv-name="dateOfBirth"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-select
            v-model="financialManagers.maritalStatus"
            label="Estado Civil*"
            v-validate="'required'"
            :error-messages="errors.collect('maritalStatus')"
            data-vv-name="maritalStatus"
            :items="estadoscivil"
            item-text="text"
            item-value="value"
            box
            ></v-select>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="financialManagers.cpf"
            label="CPF*"
            v-validate="'required|cpf'"
            disabled
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="financialManagers.susNumber"
            label="CNS (Cartão do SUS)"
            v-validate="'cns'"
            :error-messages="errors.collect('cns')"
            data-vv-name="cns"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="financialManagers.rg"
            label="RG*"
            v-validate="'required'"
            :error-messages="errors.collect('rg')"
            data-vv-name="rg"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="financialManagers.rgEmitter"
            label="Órgão Expedidor*"
            v-validate="'required'"
            :error-messages="errors.collect('rgEmissor')"
            data-vv-name="rgEmissor"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg6>      
            <v-text-field
            v-model="financialManagers.motherName"
            label="Nome da Mãe*"
            v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
            :error-messages="errors.collect('motherName')"
            data-vv-name="motherName"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg6>      
            <v-text-field
            v-model="financialManagers.email"
            label="E-mail"
            box
            disabled
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="financialManagers.homePhone"
            return-masked-value mask="(##)####-####"
            label="Telefone Fixo"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="financialManagers.cellPhone"
            label="Celular*"
            return-masked-value mask="(##)#####-####"
            box
            disabled
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="financialManagers.cellPhone2"
            label="Whatsapp"
            return-masked-value mask="(##)#####-####"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg12>      
            <p class="form-titulo">Resumo da proposta</p>
          </v-flex>           
          <v-flex xs12 sm12 lg2>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Beneficiário Titular</p>
              <span class="subtotal">R$ {{valorTitular.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg2>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Dependente(s)</p>
              <span class="subtotal">R$ {{valorDependentes.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg4>
          <div class="resumo" v-if="planoSelecionado.taxaImplantacao != '0,00'">
                  <p style="margin-bottom: 0px;">Total a pagar + Taxa de Implantação</p>
                  <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>                    
          </div>
          <div class="resumo" v-else>
              <p style="margin-bottom: 0px;">Total a pagar</p>
              <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
          </div>          
          <br>
          </v-flex> 
          <v-flex xs12 sm12 lg12  v-if="planoSelecionado.taxaImplantacao != '0,00'">
            <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pessoa (Apenas na primeira mensalidade)</p> 
          </v-flex>
        </v-layout>
        </v-card>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#004899"
            @click="avancaPasso3()"
            >Continuar
        </v-btn>

        <v-btn
            style="border-radius: 8px; width: 250px;"
            large                            
            dark
            @click="salvarContinuar()"
            color="blue-grey darken-1"
        >Salvar e continuar depois</v-btn>
        </v-container>
      </v-stepper-content>
    <!-- FIM DO PASSO 2 -->


  <!-- PASSO 3 --> 
      <v-stepper-content step="3">
        <v-container grid-list-md>
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-layout row wrap >

        <!-- RG1 -->
        <v-flex xs12 sm12 lg3>                
        <file-upload
        class="btn btn-primary"
          input-id="file1"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesRg1"
          @input-filter="inputFilter"
          @input-file="inputFileRg1"
          ref="upload1">
          <p class="form-titulo" style="font-size: 20px">RG (FRENTE)</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#004899"
            >Selecionar arquivo
        </v-btn> 
        <p id="rg1" value="" hidden></p>     
        <p v-if="filesRg1 == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p v-for="(file) in filesRg1" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>              
        </v-flex>

       <!-- RG2 --> 
      <v-flex xs12 sm12 lg3>    
        <file-upload
        class="btn btn-primary"
          input-id="file2"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesRg2"
          @input-filter="inputFilter"
          @input-file="inputFileRg2"
          ref="upload2">
          <p class="form-titulo" style="font-size: 20px">RG (VERSO)</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#004899"
            >Selecionar arquivo
        </v-btn>  
        <p id="rg2" value="" hidden></p>    
        <p v-if="filesRg2 == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p v-for="(file) in filesRg2" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>                        
        </v-flex>

      <!-- CPF --> 
      <v-flex xs12 sm12 lg3>    
        <file-upload
        class="btn btn-primary"
          input-id="file3"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesCPF"
          @input-filter="inputFilter"
          @input-file="inputFileCPF"
          ref="upload3">
          <p class="form-titulo" style="font-size: 20px">CPF</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#004899"
            >Selecionar arquivo
        </v-btn>  
        <p id="cpf" value="" hidden></p>    
        <p v-if="filesCPF == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p v-for="(file) in filesCPF" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>                        
        </v-flex>

      <!-- ENDEREÇO --> 
      <v-flex xs12 sm12 lg3>    
        <file-upload
        class="btn btn-primary"
          input-id="file4"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesAddress"
          @input-filter="inputFilter"
          @input-file="inputFileAddress"
          ref="upload4">
          <p class="form-titulo" style="font-size: 20px">Comp. de Endereço</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#004899"
            >Selecionar arquivo
        </v-btn>     
        <p id="address" value="" hidden></p> 
        <p v-if="filesAddress == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p v-for="(file) in filesAddress" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>                        
        </v-flex>

      <!-- OUTROS --> 
      <v-flex xs12 sm12 lg3>    
        <file-upload
        class="btn btn-primary"
          input-id="file5"
          extensions="pdf,gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          post-action="/upload/post"
          v-model="filesOutros"
          @input-filter="inputFilter"
          @input-file="inputFileOutros"
          ref="upload5">
          <p class="form-titulo" style="font-size: 20px">Outros</p>
          <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#004899"
            >Selecionar arquivo
        </v-btn>  
        <p id="outros" value="" hidden></p>    
        <p v-if="filesOutros == ''">Nenhum arquivo selecionado</p>
        <div v-else>                    
          <p v-for="(file) in filesOutros" :key="file.id">{{file.name}}</p>
        </div>              
        </file-upload>                        
        </v-flex>

        </v-layout>
        </v-card>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#004899"
            @click="avancaPasso4()"
            >Continuar
        </v-btn>

        <v-btn
            style="border-radius: 8px; width: 250px;"
            large                
            dark
            color="blue-grey darken-1"
            @click="salvarContinuar()"
        >Salvar e continuar depois</v-btn>
        </v-container>
      </v-stepper-content>

      <!-- FIM DO PASSO 3 -->



    <!-- PASSO 4 --> 
      <v-stepper-content step="4">
        <v-container grid-list-md>
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-layout row wrap>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="financialManagers.cep"
            label="CEP*"
            return-masked-value mask="#####-###"
            v-validate="'required'"
            :error-messages="errors.collect('cep')"
            data-vv-name="cep"
            @blur="retornoViaCEP()"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg9>      
            <v-text-field
            v-model="financialManagers.address"
            label="Rua"
            box
            disabled
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-text-field
            v-model="financialManagers.addressNumber"
            label="Número*"
            type="number"
            v-validate="'required'"
            :error-messages="errors.collect('numero')"
            data-vv-name="numero"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="bairro"
            label="Bairro"
            box
            disabled
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="cidade"
            label="Cidade"
            box
            disabled
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="estado"
            label="Estado"
            box
            disabled
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg12>
            <v-text-field
            v-model="financialManagers.addressComplement"
            label="Complemento"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg12>      
            <p class="form-titulo">Resumo da proposta</p>
          </v-flex>           
          <v-flex xs12 sm12 lg2>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Beneficiário Titular</p>
              <span class="subtotal">R$ {{valorTitular.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg2>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Dependente(s)</p>
              <span class="subtotal">R$ {{valorDependentes.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg4>
          <div class="resumo" v-if="planoSelecionado.taxaImplantacao != '0,00'">
                  <p style="margin-bottom: 0px;">Total a pagar + Taxa de Implantação</p>
                  <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>                    
          </div>
          <div class="resumo" v-else>
              <p style="margin-bottom: 0px;">Total a pagar</p>
              <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
          </div>          
          <br>
          </v-flex> 
          <v-flex xs12 sm12 lg12  v-if="planoSelecionado.taxaImplantacao != '0,00'">
            <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pessoa (Apenas na primeira mensalidade)</p> 
          </v-flex>
        </v-layout>
        </v-card>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#004899"
            @click="avancaPasso5()"
            >Continuar
        </v-btn>

        <v-btn
            style="border-radius: 8px; width: 250px;"
            large                
            dark
            color="blue-grey darken-1"
            @click="salvarContinuar()"
        >Salvar e continuar depois</v-btn>
        </v-container>
      </v-stepper-content>

      <!-- FIM DO PASSO 4 -->

      <!-- PASSO 5 -->
  <v-stepper-content step="5">      
    <v-container fluid grid-list-md>
    <v-data-iterator
      v-if="!alertTitular"
      :items="dependentes"
      :rows-per-page-items="rowsPerPageItems"
      rows-per-page-text="Linhas por página" 
      :pagination.sync="pagination"
      content-tag="v-layout"
      hide-actions
      row
      wrap
    >
      <template v-slot:header>
        <v-toolbar
          style="border-radius: 10px;"
          class="mb-2"
          color="#004899"
          dark
          flat
        >
    <v-toolbar-title>Titular/Dependentes</v-toolbar-title>
      </v-toolbar>
      </template>
      <template v-slot:item="props">
        <v-flex
          xs12
          sm6
          md4
          lg4
        >
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center;" class="subheading font-weight-bold">{{ props.item.firstName.toUpperCase() }}</v-card-title>

            <v-divider></v-divider>

            <v-list dense>

              <v-list-tile>
                <v-list-tile-content class="centralizar" >{{ props.item.namePlan}}</v-list-tile-content>
              </v-list-tile>
              
              <v-list-tile>
                <v-list-tile-content class="centralizar" >{{ props.item.parentage == '' ? 'TITULAR' : props.item.parentage}}</v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content class="centralizar" >R$ {{ props.item.valuePlan }}</v-list-tile-content>
              </v-list-tile>              

              <v-list-tile>                
                <v-btn
                style="border-radius: 8px;"                                
                dark
                color="blue-grey darken-1"
                @click="editItem(props.item)"
                >Editar
                </v-btn>
                <v-btn
                v-if="!props.item.isHolder"
                style="border-radius: 8px;"                                
                dark
                color="error"
                @click="openDialogDelete(props.item)"
                >Excluir
                </v-btn>                
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </template>      
    </v-data-iterator>
  </v-container>
    <!-- DIALOG DA LISTA DE BENEFICIARIOS -->
    <v-flex xs12 sm12 lg12>
      <v-container grid-list-md v-if="!alertTitular">
        <v-layout row wrap justify-center>
          <v-btn
            @click="openDialogDependete()"                 
            dark              
            style="border-radius: 8px;"
            large                
            color="#cc9966"
            >
            Incluir Dependente
            </v-btn>
        </v-layout>
      </v-container>         
  </v-flex>
    <v-dialog v-model="dialog" max-width="850px" persistent>                      
      <v-card>                                                        
        <v-card-title v-if="!dependents.isHolder">
          <span class="headline">{{ formTitle }}</span>                               
        </v-card-title>
        <v-card-title v-else>
          <span class="headline">{{ formTitleTitular }}</span>                               
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>   
              <v-flex xs12 sm12 lg12 v-if="dependents.isHolder">
                <v-select  
                disabled              
                v-model="selecaoPlano"
                label="Plano Selecionado*"                
                :items="planos"
                :error-messages="errors.collect('selecaoplan')"
                data-vv-name="selecaoplan"
                item-text="descricao"
                item-value="id"
                box
                @input="selecionaPlanoDepend()"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 lg12 v-else>
                <v-select             
                v-model="selecaoPlano"
                label="Plano Selecionado*"                
                :items="planos"
                :error-messages="errors.collect('selecaoplan')"
                data-vv-name="selecaoplan"
                item-text="descricao"
                item-value="id"
                box
                @input="selecionaPlanoDepend()"
                ></v-select>
              </v-flex>              
              <v-flex xs12 sm12 lg4
              v-if="!dependents.isHolder">      
                <v-select                
                v-model="dependents.parentage"
                label="Parentesco*"
                v-validate="'required'"
                :error-messages="errors.collect('parentage')"
                data-vv-name="parentage"
                :items="parentesco"
                item-text="text"
                item-value="value"
                box
                ></v-select>
                </v-flex>
              <v-flex xs12 sm12 lg8
              v-if="!dependents.isHolder">      
                <v-text-field
                v-model="dependents.firstName"
                label="Nome Completo*"
                box
                v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                :error-messages="errors.collect('firstNameDep')"
                data-vv-name="firstNameDep"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 lg12
              v-else>      
                <v-text-field
                v-model="dependents.firstName"
                label="Nome Completo*"
                box
                v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                :error-messages="errors.collect('firstNameDep')"
                data-vv-name="firstNameDep"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 lg4>      
                <v-text-field
                v-model="dependents.cpf"
                label="CPF*"
                v-validate="'required|cpf'"
                :error-messages="errors.collect('cpfDep')"
                return-masked-value mask="###.###.###-##"
                data-vv-name="cpfDep"
                box
                ></v-text-field>
                </v-flex>              
                <v-flex xs12 sm12 lg4>      
                <v-text-field
                v-model="dataNascDependent"
                label="Data de Nascimento*"
                v-validate="'required|date_format:dd/MM/yyyy'"
                :error-messages="errors.collect('dateOfBirthDep')"
                return-masked-value mask="##/##/####"
                data-vv-name="dateOfBirthDep"
                box
                ></v-text-field>
                </v-flex>                            
                <v-flex xs12 sm12 lg4>      
                <v-text-field
                v-model="dependents.susNumber"
                label="CNS (Cartão do SUS)"
                v-validate="'cns'"
                :error-messages="errors.collect('cns')"
                data-vv-name="cns"                
                box
                ></v-text-field>
                </v-flex> 
                <v-flex xs12 sm12 lg3>      
                <v-select
                v-model="dependents.maritalStatus"
                label="Estado Civil*"
                v-validate="'required'"
                :error-messages="errors.collect('maritalStatusDep')"
                data-vv-name="maritalStatusDep"
                :items="estadoscivil"
                item-text="text"
                item-value="value"
                box
                ></v-select>
            </v-flex>
              <v-flex xs12 sm12 lg3>      
                <v-select
                v-model="dependents.gender"
                label="Sexo*"
                v-validate="'required'"
                :error-messages="errors.collect('genderDep')"
                data-vv-name="genderDep"
                :items="generos"
                item-text="text"
                item-value="value"
                box
                ></v-select>
                </v-flex>               
                <v-flex xs12 sm12 lg6>      
                <v-text-field
                v-model="dependents.motherName"
                label="Nome da Mãe*"
                v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                :error-messages="errors.collect('motherNameDep')"
                data-vv-name="motherNameDep"
                box
                ></v-text-field>
                </v-flex>                                                    
            </v-layout>
            </v-container>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
          <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="salvarDependente()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DIALOG DEPENDENTES --> 

     <!-- DIALOG DELETA DEPENDENTE -->
    <v-dialog v-model="dialogDelete" max-width="600px" persistent> 
      <v-card>
        <v-card-title>
          <span class="headline">Confirmação de Exclusão</span>
        </v-card-title>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-card-text>Dependente: {{dependents.firstName}}</v-card-text>
              <v-card-text>Parentesco: {{dependents.parentage}}</v-card-text>
            </v-layout>
          </v-container>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" dark style="border-radius: 8px; width: 130px;" @click.native="deleteDependente()">Excluir</v-btn>
          <v-btn color="blue-grey darken-1" dark style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DIALOG DELETA DEPENDENTE -->

     <!-- DIALOG CARTÃO DE CRÉDITO -->
    
    <!-- FIM DIALOG CARTÃO DE CRÉDITO --> 
    
        <br>
        <v-flex xs12 sm12 lg12 v-if="alertTitular">
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-btn
                style="border-radius: 8px;"
                large                
                dark
                color="#cc9966"
                @click="openDialog()"
                >Incluir Titular
            </v-btn>
            </v-layout>
          </v-container>
          <br>
          <br>
        </v-flex>
    <div class="separator dark"></div>
    <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 sm12 lg12>      
            <p class="form-titulo">Resumo da proposta</p>
          </v-flex>           
          <v-flex xs12 sm12 lg2>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Beneficiário Titular</p>
              <span class="subtotal">R$ {{valorTitular.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg2>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Dependente(s)</p>
              <span class="subtotal">R$ {{valorDependentes.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg4>
          <div class="resumo" v-if="planoSelecionado.taxaImplantacao != '0,00'">
                  <p style="margin-bottom: 0px;">Total a pagar + Taxa de Implantação</p>
                  <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>                    
          </div>
          <div class="resumo" v-else>
              <p style="margin-bottom: 0px;">Total a pagar</p>
              <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
          </div>          
          <br>
          </v-flex> 
          <v-flex xs12 sm12 lg12  v-if="planoSelecionado.taxaImplantacao != '0,00'">
            <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pessoa (Apenas na primeira mensalidade)</p> 
          </v-flex>
        </v-layout>
      </v-container>    
     <!-- FIM DO DIALOG DA LISTA DE BENEFICIARIOS -->
    <v-card-actions>
      <v-container grid-list-md>
      <v-layout row wrap>
      <v-flex md12 xs12 sm12 lg2>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#004899"
            @click="avancaPasso6()"
            >Continuar
        </v-btn>
      </v-flex>
      <v-flex md12 xs12 sm12 lg2>
        <v-btn  
            @click="salvarContinuar()"          
            style="border-radius: 8px; width: 250px;"
            large                
            dark
            color="blue-grey darken-1"
        >Salvar e continuar depois
        </v-btn>
      </v-flex>
      </v-layout>
    </v-container>
    </v-card-actions>
      </v-stepper-content>

      <!-- FIM DO PASSO 5 -->

      <!--  PASSO 6 -->
      <v-stepper-content step="6">
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-container grid-list-md>
          <v-layout row wrap>
          <v-flex xs12 sm12 lg12 v-if="exibeVendedor">      
            <p class="form-titulo" >Corretor</p>          
          <v-flex xs12 sm12 lg12>            
            <v-radio-group v-model="temVendedor" row :disabled="linkVendedor">
                <strong style="font-weight: bold;">Você foi auxiliado por algum corretor? &nbsp;&nbsp;</strong>
                <v-radio color="#446fb5" label="Sim" :value="true"></v-radio>
                <v-radio color="#446fb5" label="Não" :value="false"></v-radio>
            </v-radio-group>
            </v-flex>
          <v-flex xs12 sm12 lg4 v-if="!linkVendedor">
                <v-text-field
                v-if="temVendedor ? true : cpfVendedor = ''"
                v-model="cpfVendedor"
                label="CPF"                
                box
                return-masked-value mask="###.###.###-##"
                :keyup="consultaVendedor()"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg8>      
            <v-text-field
            v-if="temVendedor ? temVendedor == true : nomeVendedor = ''"
            v-model="nomeVendedor"
            label="Corretor"
            box
            disabled
            ></v-text-field>
            </v-flex>
            <hr>
            <br>
          </v-flex>
          <!-- <v-flex xs12 sm12 lg12>      
            <p class="form-titulo" >Contrato</p>
          </v-flex>
          <v-flex xs12 sm3 md12>
            <v-checkbox
            v-model="contrataccept"
              label=""
              color="#004899"             
          >  
          <span slot="label">Li e concordo com os <a @click.stop :href="`${planoSelecionado.urlMinutaContrato}`" 
            target="popup" 
            :onclick="`window.open('${planoSelecionado.urlMinutaContrato}','popup','width=800,height=600'); return false;`">termos do contrato</a></span>                  
          </v-checkbox>
          </v-flex>
          <hr>
          <br> -->
          <v-flex xs12 sm12 lg12>      
            <p class="form-titulo" >Contrato</p>
          </v-flex>
         <v-flex xs12 sm12 md12 lg8 v-if="planoSelecionado.urlMinutaContrato != '' && planoSelecionado.urlMinutaContrato != undefined">
            <iframe v-if="this.$vuetify.breakpoint.lg" :src="`${pdfSelecionado}`" width="680" height="400" style="border: none;"></iframe>
          </v-flex>
          <v-flex xs12 sm12 md12 lg4>             

          <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
            v-if="planoSelecionado.urlMinutaContrato != '' && planoSelecionado.urlMinutaContrato != undefined"
            @click="pdfSelecionado = planoSelecionado.urlMinutaContrato" avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Minuta do Contrato</v-list-tile-title>
            </v-list-tile>
            </div>
          <div v-else>
            <v-list-tile
            v-if="planoSelecionado.urlMinutaContrato != '' && planoSelecionado.urlMinutaContrato != undefined"
            @click="pdfSelecionado = planoSelecionado.urlMinutaContrato" :href="planoSelecionado.urlMinutaContrato" target='_blank' avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Minuta do Contrato</v-list-tile-title>
            </v-list-tile>
            </div>

            <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
            v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined"
            @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
            </v-list-tile>
            </div>
            <div v-else>
            <v-list-tile
            v-if="planoSelecionado.urlMinutaAditivo != '' && planoSelecionado.urlMinutaAditivo != undefined"
            @click="pdfSelecionado = planoSelecionado.urlMinutaAditivo" :href="planoSelecionado.urlMinutaAditivo" target='_blank' avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Minuta do Aditivo</v-list-tile-title>
            </v-list-tile>
            </div>


            <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
            v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined"
            @click="pdfSelecionado = planoSelecionado.urlCobertura" avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
            </v-list-tile>
            </div>
            <div v-else>
            <v-list-tile
            v-if="planoSelecionado.urlCobertura != '' && planoSelecionado.urlCobertura != undefined"
            @click="pdfSelecionado = planoSelecionado.urlCobertura" :href="planoSelecionado.urlCobertura" target='_blank' avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Cobertura do Plano</v-list-tile-title>
            </v-list-tile>
            </div>


            <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
            v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined"
            @click="pdfSelecionado = planoSelecionado.urlManual" avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Manual de Orientação</v-list-tile-title>
            </v-list-tile>
            </div>
            <div v-else>
            <v-list-tile
            v-if="planoSelecionado.urlManual != '' && planoSelecionado.urlManual != undefined"
            @click="pdfSelecionado = planoSelecionado.urlManual" :href="planoSelecionado.urlManual" target='_blank' avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Manual de Orientação</v-list-tile-title>
            </v-list-tile>
            </div>            


            <div v-if="this.$vuetify.breakpoint.lg">
            <v-list-tile
            v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined"
            @click="pdfSelecionado = planoSelecionado.urlGuia" avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
            </v-list-tile>
            </div>
            <div v-else>
            <v-list-tile
            v-if="planoSelecionado.urlGuia != '' && planoSelecionado.urlGuia != undefined"
            @click="pdfSelecionado = planoSelecionado.urlGuia" :href="planoSelecionado.urlGuia" target='_blank' avatar
            >
            <v-list-tile-action>
              <img src="../Content/images/pdf.png" width="30px">
            </v-list-tile-action>
              <v-list-tile-title>Guia de Leitura Contratual</v-list-tile-title>
            </v-list-tile>
            </div>

          </v-flex>
          <v-flex xs12 sm3 md12 lg12>
            <v-checkbox
            v-model="contrataccept"
              color="#004899"
          >
          <span slot="label">Li e concordo com os termos do contrato<!-- <a @click.stop :href="this.planoSelecionado[8]"
            target="popup" 
            :onclick="`window.open(${this.planoSelecionado[8]},popup,width=800,height=600); return false;`">termos do contrato</a> --></span>
          </v-checkbox>
          </v-flex>

          <hr>
          <br>
          <v-flex xs12 sm12 lg12>      
            <p class="form-titulo" >Resumo da proposta</p>
          </v-flex>
          <v-flex xs12 sm12 lg3>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Beneficiário Titular</p>
              <span class="subtotal">R$ {{valorTitular.replace('.',',')}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg3>
          <div class="resumo">
              <p style="margin-bottom: 0px;">Dependente(s)</p>
              <span class="subtotal">R$ {{valorDependentes}}</span>
          </div>
          </v-flex>
          <v-flex xs12 sm12 lg4>
          <div class="resumo" v-if="planoSelecionado.taxaImplantacao != '0,00'">
                  <p style="margin-bottom: 0px;">Total a pagar + Taxa de Implantação</p>
                  <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>                    
          </div>
          <div class="resumo" v-else>
              <p style="margin-bottom: 0px;">Total a pagar</p>
              <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
          </div>          
          <br>
          </v-flex> 
          <v-flex xs12 sm12 lg12  v-if="planoSelecionado.taxaImplantacao != '0,00'">
            <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pessoa (Apenas na primeira mensalidade)</p> 
          </v-flex>
        <v-flex md12 xs12 sm12 lg12>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#004899"
            @click="enviarProposta()"          
            >Enviar Proposta
        </v-btn>
      </v-flex>     
        </v-layout>
        </v-container>
        </v-card>

      </v-stepper-content>      
    </v-stepper-items>
  </v-stepper>
  <!-- FIM DO PASSO 6 -->

  <v-dialog v-model="dialogLoading" max-width="450px" max-height="300px" persistent> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Parabéns</span>              
              </v-card-title>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" style="text-align: center;">Sua proposta nº <span style="font-weight: 700;">{{financialManagers.proposalNumber}}</span> foi enviada para averbação com desconto em Folha de Pagamento junto ao órgão e terá um prazo de até 72 horas para resposta. Você poderá acompanhar o andamento da sua Proposta na Área do Cliente.</p>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
              <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="confirmaContrato()">Fechar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
    </section>
    <loading :active.sync="isLoading" 
    :can-cancel="true" 
    color="#004899"
    :is-full-page="fullPage"></loading>    
    <Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { baseApiUrl } from '@/global'
import CpfValidate from '../components/validators/rules/cpf'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {

components: {Snackbar, FileUpload, Loading},
    data(){
        return {
            fullPage: true,  
            isLoading: false,          
            filesRg1: [],
            filesRg2: [],
            filesCPF: [],
            filesAddress: [],
            filesOutros: [],            
            Anexos:
              {
                id: "ID_RESPONSAVEL_FINANCEIRO",
                imagesDocs: {
                  cpf: "",
                  rg: "",
                  rg2: "",
                  address: "",
                  credtFrontal: "",
                  physicalContract: "",
                  adtive: "",
                  others: ""
                }
              },
            rowsPerPageItems: [12, 18],
            pagination: {
              rowsPerPage: 12
            },
            qtdTitular: 1,
            qtdDependentes: '',
            qtdDependentesInseridos: 0,            
            msgLoading: '',
            exibeVendedor: true,
            loading: false,
            financialManagUF: '',
            salesOrale: '5cc0a27ee2cead066040bfc9',
            brokerOrale: '5cc0a118e2cead066040bfc6',
            contrataccept: false,
            temVendedor: false,
            nomeVendedor: '',
            vendedorLink: [],
            vendedor: [],
            salesman: [],
            dependentesCarregados: [],
            linkVendedor: false,
            cpfVendedor: '',
            usarDadosFM: true,
            existeTitular: false,
            tipoTitular: false,
            radioBTtitular: true,
            alertTitular: false,
            editPassos: false,
            editedIndex: '',
            editedIndexTitular: '',
            valorDependentes: '0,00',
            valorTotalProposta: '0,00',
            valorTitular: '0,00',
            search: '',
            dialog: false,
            dialogDelete: false,
            dialogLoading: false,
            dialogCartao: false,
            dependentes: [], 
            AtualFinancialManagers: [],           
            e1: 0,
            bairro: '',
            cidade: '',
            estado: '',
            estados: [],
            parentesco: [  
            { value: 'CÔNJUGE', text: "CÔNJUGE" },
            { value: 'FILHO', text: "FILHO(A)" },
            { value: 'PAI/MÃE', text: "PAI/MÃE" },
            { value: "AGREGADO", text: "AGREGADO" },
            { value: 'AGREGADO', text: "IRMÃO(A)" },
            { value: 'AGREGADO', text: "SOBRINHO(A)" },
            { value: 'AGREGADO', text: "NETO(A)" }             
            ],
            generos: [
            { value: 1, text: "Masculino" },
            { value: 0, text: "Feminino" } ],
            estadoscivil: [
            { value: "SOLTEIRO", text: "Solteiro(a)" },
            { value: "CASADO", text: "Casado(a)" },
            { value: "VIÚVO", text: "Viúvo(a)" },
            { value: "DIVORCIADO", text: "Divorciado(a)" } ],
            planoSelecionado: {
              id: '',
              name: '',
              registro: '',
              cobertura: '',
              value: '0,00',
              oldValue: '0,00',
              taxaImplantacao: '0,00',
              familyTable: {
                value2: '',
                value3: '',
                value4: '',
                value5: '',
                value6: ''
              }
            },
            selecaoPlano: '',
            planos: [],
            namePlan: '',
            pdfSelecionado: '',
            dataNasc: '',
            dataNascDependent: '',
            dependents: {
              parentage: '',
              valuePlan: '',
              lackOfCare: 1,
              rcaId: '',
              dateFirstPayment: '',
              isHolder: '',
              financialManagerId: '',
              firstName: '',
              lastName: '',
              dateOfBirth: '',
              gender: '',
              maritalStatus: '',
              cpf: '',
              motherName: '',
              susNumber: '',
              plansId: ''
            },
            defaultDependents: {
              parentage: '',
              valuePlan: '',
              lackOfCare: 1,
              rcaId: '',
              dateFirstPayment: '',
              isHolder: '',
              financialManagerId: '',
              firstName: '',
              lastName: '',
              dateOfBirth: '',
              gender: '',
              maritalStatus: '',
              cpf: '',
              motherName: '',
              susNumber: '',
              plansId: ''
            },
            financialManagers:{
                qtdDependentes: '',
                contratanteTitular: true,
                confirmPassword: '',
                password: '',
                rg: '',
                rgEmitter: '',
                homePhone: '',
                cellPhone: '',
                cellPhone2: '',
                email: '',
                cep: '',
                address: '',
                addressType: '',
                addressTypeName: '',
                addressNumber: '',
                addressComplement: '',
                district: '',
                city: '',
                state: '',
                proposalNumber: 0,
                contractNumberS4: '',
                responsibility: '',
                cardNumber: '',
                cardValidity: '',
                cardFlag: '',
                cardDayExpiration: 15,
                dateSignatureContract: '',
                formOfPayment: '',
                formOfPaymentId: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                gender: null,
                maritalStatus: null,
                cpf: '',
                motherName: '',
                susNumber: '',
                plansId: '',
                nsu: '',
                TypeFm: 'SERVIDOR',
                protocoloCancelamento: '',
                vendedor: '',
                CPFVendedor: '',
                admissionDate: '',
                matricula: '',
                stageForm: 2,
                tempPassword: false,
                originRegister: 'EXTERNO',
                existSales: '',
                salesmanId: '5cc0a27ee2cead066040bfc9',
                brokerId: '5ee3a801373968676f2b614d',
                orgaoAverbadorId: ''                           
            },
            defaultfinancialManagers:{
                qtdDependentes: '',
                contratanteTitular: true,
                confirmPassword: '',
                password: '',
                rg: '',
                rgEmitter: '',
                homePhone: '',
                cellPhone: '',
                cellPhone2: '',
                email: '',
                cep: '',
                address: '',
                addressType: '',
                addressTypeName: '',
                addressNumber: '',
                addressComplement: '',
                district: '',
                city: '',
                state: '',
                proposalNumber: 0,
                contractNumberS4: '',
                responsibility: '',
                cardNumber: '',
                cardValidity: '',
                cardFlag: '',
                cardDayExpiration: -1,
                dateSignatureContract: '',
                formOfPayment: '',
                formOfPaymentId: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                gender: null,
                maritalStatus: null,
                cpf: '',
                motherName: '',
                susNumber: '',
                plansId: '',
                nsu: '',
                TypeFm: 'SERVIDOR',
                protocoloCancelamento: '',
                vendedor: '',
                CPFVendedor: '',
                matricula: '',
                stageForm: 2,
                tempPassword: false,
                originRegister: 'EXTERNO',
                existSales: '',
                salesmanId: '5cc0a27ee2cead066040bfc9',
                brokerId: '5ee3a801373968676f2b614d',
                orgaoAverbadorId: ''                                    
            },
            validarEmail: true,
            validarDataNascTit: true,
            validarDataNascDep: true,
            Sales: {
              status: 'EM AVERBAÇÃO',
              fMIPConfirm: '',
              fMConfirm: '',
              salesmanIPConfirm: '',
              financialManagerId: '',
              salesmanId: '',
              brokerId: '',
              salesmanConfirm: '',
              paymentId: ''
            },
            formOfPayment: {
              costCenterId: '',
              dayInclusion: '',
              type: ''
            },
            validadeCartao: '',            
            steppers: {
              default: 0,
              type: Number
            },
            idUser: '',
            dictionary: {          
                custom: {
                uf: {
                    required: () => 'Informe a UF',
                },
                matricula: {
                    required: () => 'Informe a Matricula',                   
                },
                firstName: {
                    required: () => 'Informe nome e sobrenome', 
                    regex: () => 'Informe nome e sobrenome'                  
                },
                firstNameDep: {
                    required: () => 'Informe nome e sobrenome', 
                    regex: () => 'Informe nome e sobrenome'                   
                },
                email: {
                    required: () => 'Informe o Email',
                    email: () => 'Informe um Email válido'
                },
                password: {
                    required: () => 'Informe a Senha',
                    confirmed: () => 'A senha não confere'
                },
                senha: {
                    required: () => 'Informe a Senha'
                },
                dateOfBirth: {
                   required: () => 'Informe a Data de Nascimento',
                   date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
                },
                dateOfBirthDep: {
                   required: () => 'Informe a Data de Nascimento',
                   date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
                },
                dateAdmission: {
                  required: () => 'Informe a Data de Admissão' 
                },
                gender: {
                   required: () => 'Informe o Sexo' 
                },
                genderDep: {
                   required: () => 'Informe o Sexo' 
                },
                maritalStatus: {
                   required: () => 'Informe o Estado Civil' 
                },
                maritalStatusDep: {
                   required: () => 'Informe o Estado Civil' 
                },
                motherName:{
                   required: () => 'Informe o nome da Mãe',
                   regex: () => 'Informe nome e sobrenome'
                },
                motherNameDep:{
                   required: () => 'Informe o nome da Mãe',
                   regex: () => 'Informe nome e sobrenome'
                },
                cep:{
                   required: () => 'Informe o CEP'
                },
                numero: {
                  required: () => 'Informe o Número, caso não tenha informe 0'
                },
                rgEmitter: {
                  required: () => 'Informe o Órgão Expedidor'
                },
                parentage: {
                  required: () => 'Informe o Parentesco'
                },
                cpfDep: {
                  required:() => 'Informe o CPF'
                },
                nomeCompCartao: {
                    required: () => 'Informe o Nome',                   
                },
                emailCartao: {
                    required: () => 'Informe o Email',
                    email: () => 'Informe um Email válido'
                },
                cpfCartao: {
                  required:() => 'Informe o CPF'
                },
                priNomeCartao: {
                  required:() => 'Informe o Primeiro Nome'
                },
                ultNomeCartao: {
                  required:() => 'Informe o Último Nome'
                },
                cepCartao: {
                  required: () => 'Informe o CEP'
                },
                ruaCartao: {
                  required: () => 'Informe a Rua'
                },
                numeroCartao: {
                  required: () => 'Informe o Número, caso não tenha informe 0'
                },
                bairroCartao: {
                  required: () => 'Informe o Bairro'
                },
                cidadeCartao: {
                  required: () => 'Informe a Cidade'
                },
                estadoCartao: {
                  required: () => 'Informe o Estado'
                },
                numCartao: {
                  required: () => 'Informe o número do cartão de crédito',
                  credit_card:() => 'Número de Cartão Inválido'
                },
                codCartao: {
                  required: () => 'Informe o código de segurança'
                },
                expiraCartao: {
                  required: () => 'Informe a data de validade do cartão',
                  date_between: () => 'Data de validade inválida',
                  date_format: () => 'Formato de data inválido'
                },
                rg: {
                  required: () => 'Informe o número do RG'
                },
                rgEmissor: {
                  required: () => 'Informe o Órgão Expedidor do RG'
                },
                Celular: {
                  required: () => 'Informe o número do Celular'
                },
                qtdDepend: {
                  required: () => 'Informe a quantidade de Dependentes'
                },
                selecaoplan: {
                  required: () => 'Necessário selecionar o plano'
                }                   
            }
            } 

        }
    },
     mounted : function(){
        this.carregaDados()
        this.pegaParametrosUrl()
        if(sessionStorage.getItem('FinancialManager') != null)
        this.continuaProposta()
        else
        {
        let planoLocal = JSON.parse(localStorage.getItem('planoSelecionado'))
        if (planoLocal && planoLocal.id) {
          this.selecaoPlano = planoLocal.id
          axios.get(`${baseApiUrl}Plans/buscarPublicoPorId?id=${planoLocal.id}`).then(res => {
            if (res.data != null) {
              this.planoSelecionado = res.data
              this.pdfSelecionado = this.planoSelecionado.urlContrato
              this.dependents.namePlan = this.planoSelecionado.name
              this.calculaPlano(this.planoSelecionado)
            }
          })
        }
/*         if(this.planoSelecionado.qualificacao.toUpperCase() == 'INDIVIDUAL')
        this.individual = true
        else
        this.individual = false */
        }
        this.$validator.localize('pt', this.dictionary)
        this.$store.dispatch('Logar')  
        
        if(sessionStorage.getItem('Vendedor') != null){
            this.vendedorLink = JSON.parse(sessionStorage.getItem('Vendedor'))
            this.temVendedor = true
            this.linkVendedor = true
            this.nomeVendedor = this.vendedorLink.linkSite            
            this.financialManagers.vendedor = this.vendedorLink.linkSite
            this.financialManagers.CPFVendedor = this.vendedorLink.cpf.replace(/[^\d]+/g,'')
            this.financialManagers.salesmanId = this.vendedorLink.id  
            this.financialManagers.brokerId = this.vendedorLink.brokerId            
        }
        //this.valorTotalProposta = parseFloat(this.planoSelecionado[0]) /* + parseFloat(this.valorTaxaImplantacao) */ 
    },
    watch: {
    dialog(val) {
    val || this.close()
      }
    },
    computed: {       
        formTitle() {
          return this.editedIndex === '' ? 'Incluir Dependente' : 'Editar Dependente'
        },
        formTitleTitular() {
          return this.editedIndexTitular === '' ? 'Incluir Titular' : 'Editar Titular'
        }
    },
    methods: {
        editItem(item) {
          this.editedIndex = item.id
          this.editedIndexTitular = item.id
          this.dependents = Object.assign({}, item)
          this.dataNascDependent = this.formatDateBrz(this.dependents.dateOfBirth)
          if(item.isHolder == true)
          this.tipoTitular = true
          else
          this.tipoTitular = false
          this.dialog = true

        },
        async continuaProposta(){   
          this.isLoading = true       
          if(sessionStorage.getItem('FinancialManager') != null){
          this.financialManagers = JSON.parse(sessionStorage.getItem('FinancialManager') || '[]')
          this.idUser = this.financialManagers.id
          this.dataNasc = this.formatDateBrz(this.financialManagers.dateOfBirth)

        //Carrega as informações do Plano
          try {
              let res = await axios.get(`${baseApiUrl}Plans/buscarPublicoPorId?id=${this.financialManagers.plansId}`) 
              if(res.data != ''){
                this.planoSelecionado = res.data 
                this.pdfSelecionado = this.planoSelecionado.urlContrato 
                this.selecaoPlano = this.financialManagers.plansId
              }              
            } catch (error) {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar plano","ERRO");
            }
          await this.calculaPlano(this.planoSelecionado)

          //Carrega as informações do Vendedor
          if(this.financialManagers.vendedor != '')
          {
            try {
                let res = await axios.get(`${baseApiUrl}Salesmans/infoPublico?linkSite=${this.financialManagers.vendedor}`) 
                if(res.data != ''){
                  this.vendedorLink = res.data 
                  this.temVendedor = true
                  this.linkVendedor = true
                  this.nomeVendedor = this.vendedorLink.linkSite  
                  this.financialManagers.salesmanId = this.vendedorLink.id  
                  this.financialManagers.brokerId = this.vendedorLink.brokerId 
                }              
              } catch (error) {
                  this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar dados do vendedor","ERRO");
              } 
            }       
            
          //Carrega estagio do Cadastro
            switch (this.financialManagers.stageForm) {
              case 2: 
                this.e1 = 2
                break;
              case 3:
                this.e1 = 3
                break;
              case 4:
                this.e1 = 4
                break;
             case 5:
                await this.carregaDependentes()
                this.e1 = 5
                //this.avancaPasso5()
                break;
              case 6:
                await this.carregaDependentes()
                await this.avancaPasso6()                
                break;
              default:
                break;
            }
            this.isLoading = false
        }
        },
         async deleteDependente() {        
           await axios.post(`${baseApiUrl}Dependents/excluirPublico`, {"id": this.editedIndex})
            .then(() => {    
                this.carregaDependentes()
                this.close()                
            })
            .catch(() => {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao excluir dependente","ERRO");              
              this.close()
              })
        },
        async carregaDados(){
            await axios.get(`${baseApiUrl}UFs/listaPublica`).then(res => {        
            if(res.data != null){      
            this.estados = res.data 
            this.financialManagers.plansId = this.planoSelecionado.id  
            }              	
          })
          try {
            let res = await axios.get(`${baseApiUrl}Plans/listaPublica?publico=Servidor`)
            for (var key in res.data) {
            if (res.data.hasOwnProperty(key)) {
                this.planos.push({                  
                  'codeS4': res.data[key].codeS4,                  
                  'familyTable': res.data[key].familyTable,
                  'id': res.data[key].id,
                  'name': res.data[key].name,                   
                  'value': res.data[key].value,
                  'descricao': res.data[key].name + " - R$" + res.data[key].value
                  });
            }
            }
            
          } catch (error) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao consultar os planos","ERRO");
          }
        },

        selecionaPlanoDepend(){
          for(var i=0; i<this.planos.length; i++) {
            if(this.planos[i].id === this.selecaoPlano) {
              this.dependents.plansId = this.planos[i].id
              this.dependents.valuePlan = this.planos[i].value
              this.dependents.namePlan = this.planos[i].name           
            }
          }
        },

        async salvarPrimeiroAcesso(){

          await this.$validator.validate('email').then(valid => {
              if (!valid)
                this.validarEmail = false
              else
                 this.validarEmail = true
            });

            if(this.financialManagers.cellPhone == '' || this.financialManagers.email == '' || this.financialManagers.firstName == '' || this.financialManagers.password == '' || this.financialManagers.cpf == '' || this.financialManagers.matricula == '' || this.financialManagers.state == '' || this.financialManagers.confirmPassword == '' || this.financialManagers.password != this.financialManagers.confirmPassword || this.financialManagers.admissionDate == '' || !this.validarEmail)
            this.$validator.validateAll()
            else{ 
            this.isLoading = true   
            
            await axios.post(`${baseApiUrl}APIS4s/AssociadosPublico`, {"cpf": this.financialManagers.cpf.replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {         
            if(res.data.Data.length > 0){      
            res.data.Data.forEach( (titular) => {
                if(titular.Dependente[0].Situacao == "1")
                    {
                      this.verificaTitularS4e = true
                    }
                else{ 
                      this.verificaTitularS4e = false
                    }
                })
              }
              else{ 
                this.verificaTitularS4e = false
              }              
            })

            if(this.verificaTitularS4e){
              this.isLoading = false
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825","Não foi possível incluir o Titular, já existe um contrato ativo para esse CPF!","ATENÇÃO")
            }
            else{
            let emailCheck = await axios.get(`${baseApiUrl}FinancialManagers/verificarEmailPublico?email=${encodeURIComponent(this.financialManagers.email)}`)
            if(!emailCheck.data.existe){
              this.financialManagers.plansId = this.planoSelecionado.id
              this.financialManagers.firstName = this.financialManagers.firstName.toUpperCase()

              if(this.financialManagers.orgaoAverbadorId == '')  
              this.financialManagers.orgaoAverbadorId = sessionStorage.getItem('orgaoAverbadorId') 

              this.financialManagers.email = this.financialManagers.email.toLowerCase()           
                await axios.post(`${baseApiUrl}FinancialManagers/salvarPropostaPublico`, this.financialManagers ).then(res => {         
                if(res.data != ''){      
                    this.idUser = res.data.id
                    this.$validator.reset()
                    this.financialManagers.proposalNumber = this.idUser.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
                    this.financialManagers.stageForm = 2
                    this.e1 = 2 
                    this.isLoading = false                   
                    }              	
                })

            }else
            {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#F9A825","Já existe um cadastro para esse email, acesse a Área do Cliente!","ATENÇÃO")
            }
            } 
          }
        },
        async avancaPasso3(){

          await this.$validator.validate('dateOfBirth').then(valid => {
              if (!valid)
                this.validarDataNascTit = false
              else
                 this.validarDataNascTit = true
            });

            if(this.dataNasc == '' || this.financialManagers.maritalStatus == null || this.financialManagers.gender == null || this.financialManagers.cpf == '' || this.financialManagers.motherName == '' || !CpfValidate(this.financialManagers.cpf) || this.financialManagers.rg == '' || this.financialManagers.rgEmitter == '' || !this.validarDataNascTit)
            this.$validator.validateAll()
            else{
            this.isLoading = true
            this.financialManagers.dateOfBirth = this.formatDate(this.dataNasc)
            await axios.post(`${baseApiUrl}FinancialManagers/salvarPropostaPublico`, this.financialManagers )
            .then(res => { 
              if(res.data != ''){
              if(this.financialManagers.contratanteTitular){
              this.dependents.valuePlan = this.planoSelecionado.value
              this.dependents.rcaId = '8'
              this.dependents.dateFirstPayment = new Date().toISOString().substr(0, 7).replace('-','')
              this.dependents.isHolder = true
              this.dependents.financialManagerId = this.idUser
              this.dependents.firstName = this.financialManagers.firstName
              this.dependents.dateOfBirth = this.financialManagers.dateOfBirth
              this.dependents.gender = this.financialManagers.gender
              this.dependents.maritalStatus = this.financialManagers.maritalStatus
              this.dependents.cpf = this.financialManagers.cpf
              this.dependents.motherName = this.financialManagers.motherName
              this.dependents.susNumber = this.financialManagers.susNumber
              this.dependents.plansId = this.planoSelecionado.id
              this.salvarTitular()
              }
              this.financialManagers.stageForm = 3
              this.e1 = 3
              this.isLoading = false
            this.alertTitular = !this.financialManagers.contratanteTitular
            this.radioBTtitular = false
            this.$validator.reset()
              }
            })
             await axios.get(`${baseApiUrl}Dependents/listarPublico?financialManagerId=${this.idUser}`)
            .then(res => {        
            if(res.data != ''){
              this.existeTitular = true
              this.alertTitular = false
            }
            })
            }
        },

        async salvarFinancialManager(){

          try {
              await axios.post(`${baseApiUrl}FinancialManagers/salvarPropostaPublico`, this.financialManagers ) 
           
            } catch (error) {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Erro Salvar Responsável Financeiro","ERRO");
            }
            /* await axios.post(`${baseApiUrl}FinancialManagers/update?[where][id]=${this.idUser}`, this.financialManagers ) 
            .catch(() => {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro Salvar Responsável Financeiro","ERRO");              
              }) */
        },
        

        async avancaPasso4(){
          this.isLoading = true
          this.Anexos.id = this.idUser
          this.Anexos.imagesDocs.rg = document.getElementById("rg1").value
          this.Anexos.imagesDocs.rg2 = document.getElementById("rg2").value
          this.Anexos.imagesDocs.cpf = document.getElementById("cpf").value
          this.Anexos.imagesDocs.address = document.getElementById("address").value
          this.Anexos.imagesDocs.others = document.getElementById("outros").value
          
/*             if(this.Anexos.imagesDocs.rg == undefined || this.Anexos.imagesDocs.rg2 == undefined || this.Anexos.imagesDocs.cpf == undefined || this.Anexos.imagesDocs.address == undefined || this.Anexos.imagesDocs.others == undefined){
              this.isLoading = false
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825","Para continuar é necessário enviar todos os arquivos!","ATENÇÃO")
            }            
            else{ */
            await axios.post(`${baseApiUrl}ImagesDocs/salvarDocsPublico`,this.Anexos )
            .then(res => {        
            if(res.data != ''){
                this.e1 = 4
                this.financialManagers.stageForm = 4 
                this.isLoading = false 
            }
            })
            .catch(() => {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar Anexos, verifique os arquivos!","ERRO"); 
              return;             
              })                    
                this.salvarFinancialManager()
        },

        
        async avancaPasso5(){
            if(this.financialManagers.cep == '' || this.financialManagers.addressNumber == null || this.financialManagers.address == '' || this.financialManagers.city == '' || this.financialManagers.state == '' || this.financialManagers.district == '')
            this.$validator.validateAll()
            else{
            this.isLoading = true

/*             if(this.financialManagers.qtdDependentes == 0)
            this.individual = true
            else
            this.individual = false */

            //SALVA OS DEPENDENTES QUE FORAM CARREGADOS
            if(this.qtdDependentesInseridos < this.financialManagers.qtdDependentes)
              this.salvarDependentesCarregados()


            this.salvarFinancialManager()
            this.carregaDependentes()
            setTimeout(() => {
            this.financialManagers.stageForm = 5
            this.e1 = 5
            this.isLoading = false
            }, 500);
            
            this.$validator.reset()                

            }
        },

        async avancaPasso6(){
/*             if(this.financialManagers.qtdDependentes  == this.qtdDependentesInseridos){  */
            this.isLoading = true  
            if(this.financialManagers.originRegister == 'INTERNO')
            this.exibeVendedor = false          
            else
            {
            this.exibeVendedor = true              
            this.financialManagers.responsibility = this.valorTotalProposta
            }
            this.financialManagers.stageForm = 6
            this.salvarFinancialManager()
            /* await axios.post(`${baseApiUrl}ImagesDocs`, {"financialManagerId" : this.idUser}  ) 
            .catch(() => {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao Salvar Docs","ERRO");              
              }) */
            this.e1 = 6
            this.isLoading = false
/*             }
            else{
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825",`Para avançar, é necessário inserir um total de ${this.financialManagers.qtdDependentes} dependente(s)`,"ATENÇÃO")
            } */
        },

        async salvarContinuar(){
            this.financialManagers.dateOfBirth = this.formatDate(this.dataNasc)
            this.financialManagers.stageForm = this.e1
            await axios.post(`${baseApiUrl}FinancialManagers/salvarPropostaPublico`, this.financialManagers ).then(res => {         
                if(res.data != ''){      
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#0288D1","Informações salvas com sucesso, para continuar depois, acesse a Área do Cliente!","INFORMAÇÃO")
                    }              	
                })
        },
        formatDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
      },
        formatDateBrz (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      formatDateCartao (date) {
        if (!date) return null

        const [year, month] = date.split('-')
        return `${month}/${year}`
      },

      async retornoViaCEP(){
          if(/^[0-9]{5}-[0-9]{3}$/.test(this.financialManagers.cep)) {
            try {
              let res = await axios.post(`${baseApiUrl}APIS4s/EnderecoPublico`, {"cep" : this.financialManagers.cep})
              if(res.data != ''){
                  this.financialManagers.address = res.data.Logradouro
                  this.cidade = res.data.Municipio
                  this.financialManagers.city = res.data.IdMunicipio
                  this.estado = res.data.Uf
                  this.financialManagers.state = res.data.IdUf
                  this.bairro = res.data.Bairro
                  this.financialManagers.district = res.data.IdBairro
                  this.financialManagers.addressType = res.data.IdTipoLogradouro
                  this.financialManagers.addressTypeName = res.data.TipoLogradouro

              } 
              else
              {
                var vmcep = this;
                vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                this.financialManagers.address = ''
                this.cidade = ''
                this.financialManagers.city = ''
                this.estado = ''
                this.financialManagers.state = ''
                this.bairro = ''
                this.financialManagers.district = ''
                this.financialManagers.addressType = '' 
              }             
              } catch (error) {
                  vmcep = this;
                  vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                  this.financialManagers.address = ''
                  this.cidade = ''
                  this.financialManagers.city = ''
                  this.estado = ''
                  this.financialManagers.state = ''
                  this.bairro = ''
                  this.financialManagers.district = ''
                  this.financialManagers.addressType = '' 
              }
          }           
      },

      async consultaVendedor(){
        if(CpfValidate(this.cpfVendedor)){
         await axios.get(`${baseApiUrl}Salesmans/infoPublico?cpf=${this.cpfVendedor}`).then(res => {        
            if(res.data != ''){
            this.vendedorLink = res.data 
            this.temVendedor = true
            //this.linkVendedor = true
            this.nomeVendedor = this.vendedorLink.linkSite 
            this.financialManagers.salesmanId = this.vendedorLink.id  
            this.financialManagers.brokerId = this.vendedorLink.brokerId 
            }
            else{
              var vmcpfvend = this;
              vmcpfvend.$refs.chamaSnackbar.snack("#F9A825","Vendedor não localizado","ATENÇÃO");
              this.nomeVendedor = '' 
           }         
          }) 
        }

      },
      async carregaDependentes(){
        //var count = 0
        try {
              let res = await axios.get(`${baseApiUrl}Dependents/listarPublico?financialManagerId=${this.idUser}`)
              if(res.data != null){      
                this.dependentes = res.data 
                this.qtdDependentesInseridos = this.dependentes.length - 1
                this.calculaPlano(this.planoSelecionado)
              }             
            } catch (error) {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao carregar os dependentes","ERRO") 
            }
      },

      async carregaFinancialManagers(){
        this.AtualFinancialManagers = this.financialManagers
      },

      async salvarTitular(){ 
          //this.existeTitular = false
          await axios.get(`${baseApiUrl}Dependents/listarPublico?financialManagerId=${this.idUser}`)
          .then(res => {        
            if(res.data && res.data.length > 0){
              this.existeTitular = true              
            }
            }) 
          if(!this.existeTitular) {                                    
          await axios.post(`${baseApiUrl}Dependents/salvarPublico`, this.dependents ).then(res => {         
          if(res.data != ''){ 
            //this.carregaDependentes()     
              }              	
          })
          }        
      },


      async enviarProposta(){
        if(this.contrataccept){
        this.isLoading = true
        this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
        this.formOfPayment.dayInclusion = 'SP' + this.financialManagers.orgaoAverbadorId
        this.formOfPayment.type = 'AVERBAÇÃO'
        this.financialManagers.formOfPayment = 'AVERBAÇÃO'         
        this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
        this.financialManagers.proposalNumber = this.idUser.replace(/[^\d]+/g,'').substr(0, 10)
        /* this.financialManagers.existSales = true */
            //await this.salvarFinancialManager()

            await this.salvarFinancialManagerEFinalizar()
            
         
        }
        else{
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta é neccesário concordar com os termos do contrato!","ATENÇÃO");
        }
      },

      
      //Salvar Sales ao finalizar contrato
      async salvarSales(){
        if(Object.entries(this.vendedorLink).length != 0)
        {
        this.Sales.brokerId = this.vendedorLink.brokerId
        this.Sales.salesmanId = this.vendedorLink.id
        await axios.get(`https://api.ipify.org/?format=json`).then(res => {         
          if(res.data != null){   
              this.Sales.fMIPConfirm = res.data.ip 
              this.Sales.salesmanIPConfirm = res.data.ip 
              }              	
          })
        this.Sales.financialManagerId = this.idUser
        this.Sales.fMConfirm = new Date().toISOString().substr(0, 10)
        this.Sales.salesmanConfirm = new Date().toISOString().substr(0, 10)
        try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/setExistSalesPublico`,this.Sales)
              if(res.data == true){ 
                this.isLoading = false
                this.dialogLoading = true
              } 
              else
              {             
                  this.isLoading = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO")  
              }             
            } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") 
            }
        }
        else
        {
        this.Sales.brokerId = this.brokerOrale
        this.Sales.salesmanId = this.salesOrale 
        await axios.get(`https://api.ipify.org/?format=json`).then(res => {         
          if(res.data != null){   
              this.Sales.fMIPConfirm = res.data.ip 
              this.Sales.salesmanIPConfirm = res.data.ip 
              }              	
          })
        this.Sales.financialManagerId = this.idUser
        this.Sales.fMConfirm = new Date().toISOString().substr(0, 10)
        this.Sales.salesmanConfirm = new Date().toISOString().substr(0, 10)
        try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/setExistSalesPublico`,this.Sales)
              if(res.data == true){ 
                this.isLoading = false
                this.dialogLoading = true
              } 
              else
              {             
                  this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO")  
              }             
            } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") 
            }
        }
      },

      async salvarDependentesCarregados(){
        for(var i=1; i<=this.financialManagers.qtdDependentes; i++) {
          this.dependents.valuePlan = this.planoSelecionado.value
          this.dependents.dateOfBirth = this.formatDate(this.dependentesCarregados[i].DataNascimento)
          this.dependents.plansId = this.planoSelecionado.id
          this.dependents.valuePlan = this.planoSelecionado.value
          this.dependents.rcaId = '8'
          this.dependents.financialManagerId = this.idUser
          this.dependents.isHolder = false
          this.dependents.firstName = this.dependentesCarregados[i].Nome
           if(this.dependentesCarregados[i].Sexo == 'M')
          this.dependents.gender = 1
          else
          this.dependents.gender = 0
          this.dependents.maritalStatus = 'SOLTEIRO'
          this.dependents.cpf = this.dependentesCarregados[i].CPF
          this.dependents.motherName = this.dependentesCarregados[i].NomeMaeDependente
          this.dependents.susNumber = this.dependentesCarregados[i].CNS
          switch (this.dependentesCarregados[i].CodGrauParentesco) {
            case 3:
                this.dependents.parentage = 'CÔNJUGE'
              break;
            case 4:
                this.dependents.parentage = 'FILHO'
              break;
            case 6:
                this.dependents.parentage = 'ENTEADO'
              break;
            case 8:
                this.dependents.parentage = 'PAI/MÃE'
              break;
            case 10:
                this.dependents.parentage = 'AGREGADO'
              break;          
            default:
              break;
          }

          try {
              let res = await axios.post(`${baseApiUrl}Dependents/salvarPublico`, this.dependents )
                if(res.data != ''){        
                    this.carregaDependentes()
                    this.dependents = Object.assign({}, this.defaultDependents)
                }                 
          } catch (error) {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um erro ao ao salvar os dependentes, tente novamente!","ERRO")
            }

        }

      },

      async salvarDependente(){
      await this.$validator.validate('dateOfBirthDep').then(valid => {
        if (!valid)
          this.validarDataNascDep = false
        else
          this.validarDataNascDep = true
      });
      //this.dependents.valuePlan = this.planoSelecionado.value
      this.dependents.dateOfBirth = this.formatDate(this.dataNascDependent)
      //this.dependents.plansId = this.planoSelecionado.id
      this.dependents.rcaId = '8'
      this.dependents.financialManagerId = this.idUser
      this.selecionaPlanoDepend()
      if(this.tipoTitular)
      {
      this.dependents.isHolder = true
      }
      else
      this.dependents.isHolder = false
        if(this.dependents.dateOfBirth == '' || this.dependents.firstName == '' || !this.validarDataNascDep || this.selecaoPlano == '')
            this.$validator.validateAll()
        else
        if(this.calculateAge(this.dependents.dateOfBirth) >= 12 && this.dependents.cpf == '')
            this.$validator.validateAll() 
        else
        if(this.dependents.isHolder == false && this.dependents.parentage == '' )
          this.$validator.validate('parentage') 
        else
        if(!CpfValidate(this.dependents.cpf) && this.dependents.cpf != '')
          this.$validator.validateAll()
            else{                               
                await axios.post(`${baseApiUrl}Dependents/salvarPublico`, this.dependents ).then(res => {         
                if(res.data != ''){    
                    this.carregaDependentes()
                    this.close()
                    //this.qtdDependentesInseridos = res.data
                    }              	
                })
            if(this.dependents.parentage == ''){
            this.alertTitular = false 
            }              
            }                 
      },
      openDialog(){
        this.tipoTitular = true
        this.$validator.reset()
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndexTitular = ''
          this.dataNascDependent = ''
          this.dependents.isHolder = true
        this.dialog = true
      },
      openDialogDependete(){
 /*        if(this.financialManagers.qtdDependentes != this.qtdDependentesInseridos){ */
        this.tipoTitular = false
        this.$validator.reset()
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndex = ''
          this.dataNascDependent = ''
        this.dialog = true
/*         }
      else{
        var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825",`Total de dependentes informado (${this.financialManagers.qtdDependentes}) atingindo!`,"ATENÇÃO");
      } */
      },
      openDialogDelete(item){
        this.editedIndex = item.id
        this.dependents = Object.assign({}, item)
        this.$validator.reset()
        this.dialogDelete = true
      },
      close() {
        this.dialogCartao = false
          this.dialogLoading = false
          this.dialog = false
          this.dialogDelete = false
          this.$validator.reset()                    
          setTimeout(() => {
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndex = ''
          this.editedIndexTitular = ''
          this.dataNascDependent = ''
          }, 300)
          
      },
      
        calculateAge(dobString) {
        var dob = new Date(dobString);
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var birthdayThisYear = new Date(currentYear, dob.getMonth(), dob.getDate());
        var age = currentYear - dob.getFullYear();
        if(birthdayThisYear > currentDate) {
          age--;
        }
        return age;
      },

      confirmaContrato(){
        this.close()
       /*  sessionStorage.clear()
        localStorage.clear() */
        this.$router.push({ path: '/areacliente' })
        setTimeout(() => {
            document.location.reload(true);
        }, 500);
      },
          
    calculaPlano(plano){
        this.valorPlano = this.planoSelecionado.value
        this.valorDependentes = '0,00'
        this.valorTitular = parseFloat(this.planoSelecionado.value.replace(',', '.')).toFixed(2)
      if(plano.taxaImplantacao != '0,00')
      {
        var totalTaxa = 0
        this.valorTitular = (parseFloat(plano.value.replace(',','.')) + parseFloat(plano.taxaImplantacao.replace(',','.'))).toFixed(2)
        if(this.qtdDependentesInseridos != '')
        {
        totalTaxa = (parseFloat(plano.taxaImplantacao.replace(',','.')) * this.qtdDependentesInseridos).toFixed(2)
        //this.valorDependentes = (parseFloat(plano.value.replace(',','.')) * this.qtdDependentesInseridos + parseFloat(totalTaxa)).toFixed(2)
        for (let index = 0; index < this.dependentes.length; index++) {
                  if(!this.dependentes[index].isHolder) {                    
                  this.valorDependentes = (parseFloat(this.valorDependentes) + parseFloat(this.dependentes[index].valuePlan.replace(',','.')) + parseFloat(totalTaxa)).toFixed(2).replace('.',',')
                  }
          }
        }
        else
        this.valorDependentes = '0.00'
        this.valorTotalProposta = (parseFloat(this.valorTitular) + parseFloat(this.valorDependentes.replace(',','.'))).toFixed(2)
      }
      else{
        if(this.qtdDependentesInseridos  != '')
        {
          for (let index = 0; index < this.dependentes.length; index++) {
                  if(!this.dependentes[index].isHolder) {
                  this.valorDependentes = (parseFloat(this.valorDependentes.replace(',','.')) + parseFloat(this.dependentes[index].valuePlan.replace(',','.'))).toFixed(2).replace('.',',')
                  }
          }
        }
        else
        this.valorDependentes = '0.00'
        this.valorTotalProposta = (parseFloat(this.valorTitular) + parseFloat(this.valorDependentes.replace(',','.'))).toFixed(2)
      }
    },

       //CONTROLE DE ANEXOS

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    
    inputFileRg1(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesRg1[0]
        
        //salva a base64 na variável
        reader.onloadend = function() { 
                  
         document.getElementById("rg1").value = reader.result            
        
        };            
        //Gera base64
        reader.readAsDataURL(file.file);  
        //this.files = []     

      }
      if (newFile && oldFile) {
        // update
      }
      if (!newFile && oldFile) {
        // remove
      }
    },
    
      inputFileRg2(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesRg2[0]
        //Gera base64
        reader.onloadend = function() { 

          document.getElementById("rg2").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },

      inputFileCPF(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesCPF[0]
        //Gera base64
        reader.onloadend = function() { 

          document.getElementById("cpf").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },

    async salvarFinancialManagerEFinalizar(){ 
            try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/salvarPropostaPublico`, this.financialManagers ) 
              if(res.data != ''){
                this.finalizaCadastro()
              }  
              else
              {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO")
              }            
              } catch (error) {
                  this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO")                
              }                       
        },

    async finalizaCadastro(){
      //PEGA O CONTRACT NUMBER S4
       try {
              let res = await axios.post(`${baseApiUrl}FormOfPayments/firstPaymentDatePublico`,this.formOfPayment)
                if(res.data != ''){        
                  this.financialManagers.contractNumberS4 = res.data.codeS4
                  //this.salvarFinancialManager()
                } 
                else
                {             
                  this.financialManagers.contractNumberS4 = ''
                  //this.salvarFinancialManager()
                }
          } catch (error) {
              this.financialManagers.contractNumberS4 = ''
              //this.salvarFinancialManager()
            }

      //ATUALIZA O FINANCIAL MANAGER E SALVA O SALES
        if(this.financialManagers.contractNumberS4 != undefined)
        {          
          try {
                  await axios.post(`${baseApiUrl}FinancialManagers/salvarPropostaPublico`, {"id": this.idUser, "contractNumberS4":this.financialManagers.contractNumberS4} )            
              } 
          catch (error) 
              {
                  this.isLoading = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro Salvar Responsável Financeiro","ERRO");
              }
        if(Object.entries(this.vendedorLink).length != 0)
        {
        this.Sales.brokerId = this.vendedorLink.brokerId
        this.Sales.salesmanId = this.vendedorLink.id
        try {
          let res = await axios.get(`https://api.ipify.org/?format=json`)
          if(res.data != null){   
              this.Sales.fMIPConfirm = res.data.ip 
              this.Sales.salesmanIPConfirm = res.data.ip 
              }
              else
              {
                this.Sales.fMIPConfirm = '127.0.0.0' 
                this.Sales.salesmanIPConfirm = '127.0.0.0'
              }
          } catch (error) {
                  this.Sales.fMIPConfirm = '127.0.0.0' 
                  this.Sales.salesmanIPConfirm = '127.0.0.0'  
          }
        this.Sales.financialManagerId = this.idUser
        this.Sales.fMConfirm = new Date().toISOString().substr(0, 10)
        this.Sales.salesmanConfirm = new Date().toISOString().substr(0, 10)
        try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/setExistSalesPublico`,this.Sales)
              if(res.data == true){ 
                this.isLoading = false
                this.dialogLoading = true
              } 
              else
              {             
                  this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO")  
              }             
            } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") 
            }
        }
        else
        {
        this.Sales.brokerId = this.brokerOrale
        this.Sales.salesmanId = this.salesOrale 
        try {
          let res = await axios.get(`https://api.ipify.org/?format=json`)
          if(res.data != null){   
              this.Sales.fMIPConfirm = res.data.ip 
              this.Sales.salesmanIPConfirm = res.data.ip 
              }
              else
              {
                this.Sales.fMIPConfirm = '127.0.0.0' 
                this.Sales.salesmanIPConfirm = '127.0.0.0'
              }
          } catch (error) {
                  this.Sales.fMIPConfirm = '127.0.0.0' 
                  this.Sales.salesmanIPConfirm = '127.0.0.0'  
          }
        this.Sales.financialManagerId = this.idUser
        this.Sales.fMConfirm = new Date().toISOString().substr(0, 10)
        this.Sales.salesmanConfirm = new Date().toISOString().substr(0, 10)
        try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/setExistSalesPublico`,this.Sales)
              if(res.data == true){ 
                this.isLoading = false
                this.dialogLoading = true
              } 
              else
              {             
                  this.isLoading = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO")  
              }             
            } catch (error) {
                this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") 
            }
          }
        }
        else
          {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um erro ao capturar a forma de pagamento, tente novamente!","ERRO")  
          }
      },

    inputFileAddress(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesAddress[0]
        //Gera base64
        reader.onloadend = function() { 

          document.getElementById("address").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },

    inputFileOutros(newFile, oldFile) {
      if (newFile && !oldFile) {        
        var reader = new FileReader();        
        var file = this.filesOutros[0]
        //Gera base643
        reader.onloadend = function() { 

          document.getElementById("outros").value = reader.result 
        
        }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
      }          

        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
    },
      //FIM CONTROLE DE ANEXOS

    async pegaParametrosUrl(){
      this.isLoading = true
      var params = window.location.search.substring(1).split('&');
      if(params[0] != ''){
      //Criar objeto que vai conter os parametros
      var paramArray = {};

      //Passar por todos os parametros
      for(var i=0; i<params.length; i++) {
          //Dividir os parametros chave e valor
          var param = params[i].split('=');

          //Adicionar ao objeto criado antes
          paramArray[param[0]] = param[1];
          }
      if(paramArray['plano'])
      {
        sessionStorage.clear()
      }
      if(paramArray['parceria'] == 'avanti')
      this.linkParceriaAvanti = true
      else
      if(paramArray['parceria'] == 'igrejas')
      this.linkParceriaIgrejas = true

      if(paramArray['carteirinha'])
      this.financialManagers.matricula = paramArray['carteirinha']

      await axios.get(`${baseApiUrl}Plans/buscarPublicoPorId?id=${paramArray['plano']}`).then(res => {        
            if(res.data != null){
            this.financialManagers.plansId = paramArray['plano']      
            this.planoSelecionado = res.data
            this.pdfSelecionado = this.planoSelecionado.urlContrato  
            this.selecaoPlano = this.financialManagers.plansId 
            }              	
      })
      if(paramArray['orgaoaverbador'])
      this.financialManagers.orgaoAverbadorId = paramArray['orgaoaverbador']

      if(paramArray['cpf'])
      {
        //DADOS PARA TODOS
        this.financialManagers.contractNumberS4 = 503895
        this.financialManagers.cpf = paramArray['cpf'] 
        
        this.$validator.localize('pt', this.dictionary)
        await axios.post(`${baseApiUrl}APIS4s/AssociadosPublico`, {"cpf": paramArray['cpf'].replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {         
            if(res.data.Data.length > 0){      
                res.data.Data.forEach( (titularContrato) => {
                  if(titularContrato.CodigoEmpresa == 5085)
                  {
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#0288D1","Detectamos que você já tem cadastro na Orale, confirme os seus dados na proposta","INFORMAÇÃO");

                  //CARREGA DEPENDENTES
                  for(var i=0; i<titularContrato.Dependente.length; i++) {

                  this.dependentesCarregados.push(titularContrato.Dependente[i])
                  }
                  //PREENCHIMENTO DOS CAMPOS
                  this.financialManagers.qtdDependentes = parseInt(titularContrato.Dependente.length -1)                
                  this.financialManagers.state = titularContrato.Uf
                  this.financialManagers.matricula = titularContrato.Matricula
                  this.financialManagers.rg = titularContrato.Identidade
                  this.financialManagers.firstName = titularContrato.Nome.trim()
                  this.financialManagers.motherName = titularContrato.Dependente[0].NomeMaeDependente.trim()
                  this.financialManagers.susNumber = titularContrato.Dependente[0].CNS
                  this.financialManagers.cpf = titularContrato.CPF
                  this.financialManagers.cep = titularContrato.Cep
                  for(var c=0; c<titularContrato.Contato.length; c++) {
                    if(titularContrato.Contato[c].Tipo == 'E-mail' && titularContrato.Contato[c].situacao == 1)
                    {
                    this.financialManagers.email = titularContrato.Contato[c].descricao.trim()
                    }

                    if(titularContrato.Contato[c].Tipo == 'Celular' || titularContrato.Contato[c].Tipo == 'Fixo' || titularContrato.Contato[c].Tipo == 'Telefone' && titularContrato.Contato[c].situacao == 1)
                    {
                    this.financialManagers.cellPhone = titularContrato.Contato[c].descricao
                    }
                  }
                  if(titularContrato.Sexo == 'M'){
                  this.financialManagers.gender = 1
                  }    
                  else
                  {
                  this.financialManagers.gender = 0
                  }
                  this.financialManagers.rg = titularContrato.Identidade
                  this.dataNasc = titularContrato.DataNascimento
                  this.financialManagers.addressNumber = titularContrato.Numero                 
                  this.financialManagers.addressComplement = titularContrato.Complemento 
                  }                          
                  })
              }             
            })

            //CALCULA O PLANO
            this.calculaPlano(this.planoSelecionado)
      }
      if(paramArray['vendedor'])
          {
          await axios.get(`${baseApiUrl}Salesmans/infoPublico?linkSite=${paramArray['vendedor']}`).then(res => {        
            if(res.data != null){
            this.vendedorLink = res.data 
            this.temVendedor = true
            this.linkVendedor = true
            this.nomeVendedor = this.vendedorLink.linkSite
            this.financialManagers.vendedor = this.vendedorLink.linkSite 
            this.financialManagers.CPFVendedor =  this.vendedorLink.cpf   
            this.financialManagers.salesmanId = this.vendedorLink.id  
            this.financialManagers.brokerId = this.vendedorLink.brokerId        
          }
          })
          } 
    }
    this.isLoading = false
    }      
  },

}
</script>

<style>
.v-table__overflow {
    border-radius: 10px;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
}

span.v-stepper__step__step.primary{
    background-color: #004899!important;
    border-color: #004899!important;
}

.theme--light.v-stepper .v-stepper__label {
    color: #004899;
}
.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #004899;
}

table.v-table thead tr th {
    background-color: #004899;
    font-size: 1rem;
  }

.v-list__tile.theme--light{
  justify-content: center;
}

.centralizar {
    text-align: left;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: none;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column;
}


  .theme--light.v-table thead th  {
    color: white;
  }

  .theme--light.v-datatable thead th.column.sortable:hover {
    color: rgb(17, 16, 16);
  }

  .theme--light.v-datatable thead th.column.sortable.active {
    color: white;
    font-weight: bold;
  }

  table.v-table thead th:first-child, table.v-table tbody th:first-child {
    padding: 15px 24px;
  }   
  .form-titulo {
    font-size: 22px;
    font-weight: 700;
    color: #004899;
    margin-bottom: 20px;
  }

  hr {
        border: 0;
        width: 100%;
        height: 1px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }
  .resumo p {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 20px;
    color: #828585;
  }
  .subtotal {
    font-weight: 700;
    font-size: 20px;
    color: #828585;
  }
  .total {
    font-size: 30px;
    color: #004899;
    line-height: 30px;
    margin-top: 5px;
    display: block;
    font-weight: bold;
  }
  .page-content p {
    margin-bottom: 0;
  }
  .cardpag{
    background-color: #004899;
    color: white;
  /*   color: #004899; */
    justify-content: center;
    font-weight: 700;
    font-size: 20px;
  }
  a{
    text-decoration: none
  }

  .imgpag{
    opacity: 0.5;
  }

</style>
